<template>
	<div class="filter">
		<div class="container">
			<div class="filter__wrap" v-if="productType != 'package' && productType != 'rentals' && productType != 'paper-goods'">
				<span class="filter__desc">Filter Food By:</span>
				<div class="filter-toggle__wrapp">
					<span class="filter__toggle" ref="toggle" @click="changeFilters">Toggle Filters</span>
				</div>
				<PartFilterItem ref="filter" v-for="filter in filters" :filter="filter" :key="filter.name"/>
			</div>

			<div class="filter__tags">
				<div v-if="searchText && searchText.length > 0" class="filter__tag filter__tag--fill">
					{{ searchText }}
					<a class="filter__delete-link" @click="removeFilter( 'text')" href="javascript:;">
						<SvgIcon class="filter__delete-icon" iconName="ico-times"/>
					</a>
				</div>
				<div v-if="category.catName" class="filter__tag filter__tag--fill">
					{{ category.catName }}
					<a class="filter__delete-link" @click="removeFilter( 'category')" href="javascript:;">
						<SvgIcon class="filter__delete-icon" iconName="ico-times"/>
					</a>
				</div>
				<div v-if="getChosenFilterDishType.filter" class="filter__tag">
					{{ getChosenFilterDishType.filter }}
					<a class="filter__delete-link" @click="removeFilter('Specialties')" href="javascript:;">
						<SvgIcon class="filter__delete-icon" iconName="ico-times"/>
					</a>
				</div>
				<div v-if="getChosenFilterEventType.filter" class="filter__tag">
					{{ getChosenFilterEventType.filter }}
					<a class="filter__delete-link" @click="removeFilter( 'Type')" href="javascript:;">
						<SvgIcon class="filter__delete-icon" iconName="ico-times"/>
					</a>
				</div>
				<div v-if="getChosenFilterPeople.filter" class="filter__tag">
					Servings: {{ getChosenFilterPeople.filter }}
					<a class="filter__delete-link" @click="removeFilter( 'People' )" href="javascript:;">
						<SvgIcon class="filter__delete-icon" iconName="ico-times"/>
					</a>
				</div>
				<div v-if="getChosenFilterPrice.filter" class="filter__tag">
					Price: {{ getChosenFilterPrice.filter }}
					<a class="filter__delete-link" @click="removeFilter( 'Price' )" href="javascript:;">
						<SvgIcon class="filter__delete-icon" iconName="ico-times"/>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import PartFilterItem from '../parts/PartFilterItem.vue';
	import SvgIcon from '../base/SvgIcon/SvgIcon.vue';

	export default {
		props: {
			productType: String
		},
		beforeMount() {
			this.$store.dispatch('setFilterDropdown');
		},
		components: {
			PartFilterItem,
			SvgIcon
		},
		computed: {
			searchText() {
				return this.$store.getters.getSearchText;
			},
			category() {
				return this.$store.getters.getSearchCat;
			},
			filters() {
				return this.$store.getters.getFilterDropdown;
			},
			getChosenFilterDishType() {
				return this.$store.getters.getChosenFilterDishType;
			},
			getChosenFilterEventType() {
				return this.$store.getters.getChosenFilterEventType;
			},
			getChosenFilterPeople() {
				return this.$store.getters.getChosenFilterPeople;
			},
			getChosenFilterPrice() {
				return this.$store.getters.getChosenFilterPrice;
			}
		},
		methods: {
			removeFilter(type) {

				if (type === 'Specialties') {
					this.$store.dispatch('setChosenFilterDishType', {});
				} else if (type === 'Type') {
					this.$store.dispatch('setChosenFilterEventType', {});
				} else if (type === 'People') {
					this.$store.dispatch('setChosenFilterPeople', {});
				} else if (type === 'Price') {
					this.$store.dispatch('setChosenFilterPrice', {});
				} else if (type === 'category') {
					this.$store.dispatch('setSearchCat', {});
				} else if (type === 'text') {
					document.querySelector('.search-box__input').value = '';
					this.$store.dispatch('setSearchText', {});
				}
				//console.log(this.productType);
				const data = {
					type: this.productType,
					text: this.searchText,
					cat: this.category.catID,
					dish: this.getChosenFilterDishType,
					event: this.getChosenFilterEventType,
					people: this.getChosenFilterPeople,
					price: this.getChosenFilterPrice,
					category: this.productsCategory
				};
				this.$store.dispatch('setSearchProducts', data);
			},
			changeFilters() {
				const item = this.$refs.toggle;
				const filterItem = document.getElementsByClassName('filter-item');

				item.classList.toggle('active');

				if (item.classList.contains('active')) {
					console.log(filterItem.length);
					for (let i=0; i<filterItem.length; i++) {
						filterItem[i].style.display = 'block';
					}
				}else {
					console.log(filterItem.length);
					for (let i=0; i<filterItem.length; i++) {
						filterItem[i].style.display = 'none';
					}
				}
			}
		},
		data() {
			return {
				// eslint-disable-next-line no-undef
				productsCategory: productsCategory,
			};
		}
	};
</script>

<style lang="scss" scoped>
	.filter {
		margin: 37px 0 59px;

		@include mq($sm) {
			margin: 37px 0 9px;
		}
	}

	.filter__wrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
		@include mq($lg) {
			flex-wrap: wrap;
		}
	}

	.filter__desc {
		font-size: 16px;
		font-weight: 500;
		text-transform: uppercase;
		letter-spacing: 0.8px;
		@include mq($lg) {
			display: block;
			width: 100%;
			margin-bottom: 20px;
		}
	}

	.filter__tags {
		display: flex;
		margin-top: 57px;
		flex-wrap: wrap;

		@include mq($lg) {
			margin-top: 30px;
		}
	}

	.filter__tag {
		display: inline-flex;
		font-family: $font-second;
		align-items: center;
		color: $happy-blue;
		font-size: 18px;
		height: 41px;
		border: 1px solid rgba($cello, 0.3);
		padding: 0 18px;
		border-radius: 21px;

		&:not(:last-of-type) {
			margin-right: 8px;
		}

		&--fill {
			border: 0;
			background-color: $iceberg;
		}

		@include mq($lg) {
			margin-bottom: 15px;
		}
	}

	.filter__delete-link {
		display: inline-flex;
		align-items: center;
		transition: $dur $ease;
		margin-left: 12px;

		&:hover {
			transform: scale(1.3);
		}
	}

	.filter__delete-icon {
		align-items: center;
		color: $happy-blue;
		font-size: 9px;
		width: 9px;
		height: 20px;
	}

	.filter-toggle__wrapp {
		display: none;
		width: 100%;
		margin-bottom: 15px;

		@include mq($md) {
			display: block;
		}
	}

	.filter__toggle {
		cursor: pointer;
		background-color: $white;
		border: 1px solid rgba(97, 143, 175, .4);
		padding: 3px 6px;
		border-radius: 6px;
		transition: 350ms ease;
	}

	.active {
		background-color: #628fb0;
		transition: 350ms ease;
		color: $white;
	}

	.filter-item {
		
		@include mq($md) {
			display: none;
		}
	}

	.visible {
		display: block;
	}
</style>
